import React, { useState } from 'react'
import _, { sortBy } from 'lodash'
import {
  Row,
  Col,
  FormInput,
  FormInputSelect
} from 'camino-react'

const QueueAssignee = ({
  hidden,
  submitAction,
  submitButtonText,
  queuesWithAssignees,
  setFieldErrorClasses,
  setFieldValue,
  queue_id,
  assignee_user_id,
  assign_to_current_user
}) => {

  const [currentAssignees, setCurrentAssignees] = useState([])

  const setAssignees = (value) => {
    setCurrentAssignees(_.find(queuesWithAssignees, ['value', value]).assignees)
  }

  const checkAssigneeIsCurrentUser = () => {
    return assign_to_current_user
  }

  if (hidden) {
    return null
  }

  return (
    <div>
      <Row>
        <Col>
          <div>
            <FormInput>
              <div>
                <label htmlFor="queue_id">Queue</label>
                <FormInputSelect
                  disabled={checkAssigneeIsCurrentUser()}
                  placeholder="Queue"
                  value={_.find(queuesWithAssignees, ({ value: queue_id }))}
                  options={sortBy(queuesWithAssignees, ({ label }) => label)}
                  onValue={(value) => {
                    setAssignees(value)
                    setFieldValue('queue_id', value)
                  }
                  }
                  clearable
                  className={setFieldErrorClasses('queue_id')}
                />
              </div>
            </FormInput>
          </div>
        </Col>

        <Col>
          <div>
            <FormInput>
              <div>
                <label htmlFor="assignee_id">Assignee</label>
                <FormInputSelect
                  disabled={checkAssigneeIsCurrentUser()}
                  placeholder="Assignee"
                  value={_.find(currentAssignees, ({ value: assignee_user_id }))}
                  options={sortBy(currentAssignees, ({ label }) => label)}
                  onValue={value => setFieldValue('assignee_user_id', value)}
                  clearable
                  className={setFieldErrorClasses('assignee_user_id')}
                />
              </div>
            </FormInput>
          </div>
        </Col>
      </Row>
      <div className="form-section">
        <div className="form-section__actions">
          <button type="button" className="button button--outline form-section__action" onClick={() => { window.location.reload(true) }}>
            Cancel
          </button>
          <button onClick={submitAction} className="form-section__action button" type="button">
            {submitButtonText}
          </button>
        </div>
      </div>
    </div>
  )
}

export default QueueAssignee